<template>
  <div class="public">
    <template v-if="showHint">
      <div class="not-first" v-if="showHint == 1" @click="close">
      </div>
      <div class="not" v-else>
        <div class="text-center"><img src="@/assets/images/device/sc.png" style="width: 70px"/></div>
        <div>您还没有收藏任何设备，请到各个设备页面进行收藏设备</div>
      </div>
    </template>
    <div class="container" v-else>

      <component :is="getComponent(device)"
                 v-for="(device,i) in devices" :device="device"
                 :key="`device_d_${i}`"></component>
      <component :is="otherComponent(device)"
                 v-for="(device,i) in otherDevices" :device="device"
                 :key="`device_other_d_${i}`"></component>
      <round class="empty"></round>
      <round class="empty"></round>
      <round class="empty"></round>
    </div>
  </div>
</template>

<script>
import cache from '@/assets/lib/cache'
import { mapState } from 'vuex'
import Light from '@/components/Light'
import MySwitch from '@/components/Switch'
import OtherSwitch from '@/components/OtherSwitch'
import AirSwitch from '@/components/Wisdom'
import Aircon from '@/components/Aircon'
import Airpure from '@/components/Airpure'
import Colorbar from '@/components/Colorbar'
import Curtain from '@/components/Curtain'
import Fan from '@/components/Fan'
import Round from '@/components/Round'
import MyVideo from '@/components/Video'
// 组
import LightGroup from '@/components/group/Light'
import CurtainGroup from '@/components/group/Curtain'
import AirconGroup from '@/components/group/Aircon'

export default {
  name: 'DevicePublic',
  data () {
    return {
      exist: cache.getCache('exist')
    }
  },
  components: {
    MyVideo,
    Light,
    MySwitch,
    Airpure,
    Aircon,
    Colorbar,
    Curtain,
    Fan,
    Round,
    LightGroup,
    CurtainGroup,
    AirconGroup,
    AirSwitch,
    OtherSwitch
  },
  computed: {
    ...mapState(['collection', 'extDevices', 'lights', 'groups', 'otherExtDevices']),
    showHint () {
      if (this.collection && this.collection.devices.length) {
        return false
      } else {
        if (this.exist) {
          return 2
        } else {
          return 1
        }
      }
    },
    devices () {
      let data = this.collection.devices.map(c => {
        let device = 0
        if (c.type === 'video') {
          return { type: 'video' }
        } else if (c.flag === 'group') {
          let findObject = this.groups.find(item => item.name === c.name && JSON.stringify(item.listId) === JSON.stringify(c.include) && item.key === c.type)
          if (findObject) {
            let obj = findObject.key === 'light' ? this.lights : this.extDevices
            let list = obj.filter(itm => findObject.listId.includes(itm.id))
            // 拼接必要字段
            let result = {
              include: findObject.listId,
              name: findObject.name,
              // state: list.some(item => item.state),
              desc: findObject.remark
            }
            list = JSON.parse(JSON.stringify(list))
            return Object.assign({}, list[0], result)
          }
        } else {
          device = c.type === 'light' ? this.lights.filter(l => l.id === c.id) : this.extDevices.filter(e => e.id === c.id)
          if (device.length) {
            return device[0]
          } else {
            return 0
          }
        }
      }).filter(c => c !== 0)
      return Object.assign([], JSON.parse(JSON.stringify(data)))
    },
    otherDevices () {
      let data = this.collection.devices.map(c => {
        let device = this.otherExtDevices.filter(e => e.unique === c.id)
        if (device.length) {
          return device[0]
        } else {
          return 0
        }
      }).filter(c => c !== 0)
      return Object.assign([], JSON.parse(JSON.stringify(data)))
    }
  },
  methods: {
    close () {
      // 写入并重新计算
      cache.setCache('exist', { exist: true }, 7)
      this.exist = cache.getCache('exist')
    },
    getComponent (device) {
      if (!device) return
      if (device.include) {
        if (device.devicetype) {
          return device.devicetype.key === 'switch' ? 'my-switch' : device.devicetype.key + '-group'
        } else {
          return 'light-group'
        }
      }
      if (device.devicetype) {
        switch (device.devicetype.key) {
          case 'switch':
            return 'my-switch'
          case 'airswitch':
            return 'air-switch'
          default:
            return device.devicetype.key
        }
      } else if (device.type === 'video') {
        return 'my-video'
      } else {
        return 'light'
      }
    },
    otherComponent (device) {
      if (!device) return
      if (device.key === 'switch') return 'other-switch'
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/base";

.public {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  > .container {
    margin-top: -20px;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    flex: 1;
    height: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    > div {
      margin-top: 20px;
    }
  }
  > .not-first {
    position: absolute;
    width: calc(100% + 40px);
    height: calc(100% + 40px);
    cursor: pointer;
    margin: -20px;
    background: url('../../assets/images/device/bjc.jpg') no-repeat;
    background-size: cover;
  }
  > .not {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 17px;
    font-weight: 400;
    color: rgba(183, 187, 191, 1);
    > div:last-child {
      margin-top: 30px;
    }
  }
}
</style>
